import React from 'react'
import { Card } from '../../components/common/card/Card'
import CardTitle from '../../components/common/card/CardTitle'
import IconDoc from '../../components/common/icon/IconDoc'

import IconWorkspace from '../../components/common/icon/IconWorkspace'
import IconEnergy from '../../components/common/icon/IconEnergy'
import IconMap from '../../components/common/icon/IconMap'
import IconCalendar from '../../components/common/icon/IconCalendar'
import IconDashboard from '../../components/common/icon/IconDashboard'
import Tooltip from '../../components/common/tooltip/Tooltip'

import IconBubbles from '../../components/common/icon/IconBubbles'
import { linkBuilder } from '../../../../shared/linkBuilder'
import { TypeOfElement } from '../../../../types/generic'
import { DashboardItemTypes } from 'front-end/src/graphql/private/PrivateSchemaTypes'
import { DashboardsQuery } from './DashboardsPage.codegen'
import { Plural } from '@lingui/macro'
import { Flex } from 'front-end/src/components'

type Dashboard = TypeOfElement<
  NonNullable<DashboardsQuery['admin']>['dashboards']
>

interface DashboardCardProps {
  dashboard: Dashboard
}

const countItems = (
  items: NonNullable<Dashboard>['items'],
  type: DashboardItemTypes
) => {
  return items?.filter((i) => i.item_type === type).length || 0
}

export const DashboardCard = ({ dashboard }: DashboardCardProps) => {
  const { items } = dashboard

  const workspacesCount = countItems(items, DashboardItemTypes.workspace)
  const topicsCount = countItems(items, DashboardItemTypes.topic)
  const pathwaysCount = countItems(items, DashboardItemTypes.pathway)
  const campaignsCount = countItems(items, DashboardItemTypes.campaign)
  const surveysCount = countItems(items, DashboardItemTypes.survey)
  const eventsCount = countItems(items, DashboardItemTypes.event)

  return (
    <Card linkUrl={linkBuilder.dashboardManage(dashboard.id)}>
      <Flex flexDirection="row">
        <IconDashboard
          style={{ backgroundColor: dashboard.color || '#00bb77' }}
        />
        <div className="Card__wrapper">
          <CardTitle title={dashboard.title || ''} />
          <div className="Card__iconsum">
            {!!workspacesCount && (
              <Tooltip
                delay={1000}
                text={
                  <Plural
                    value={workspacesCount}
                    one="# workspace"
                    other="# workspaces"
                  />
                }
              >
                <Flex align="center">
                  <IconWorkspace />
                  {workspacesCount}
                </Flex>
              </Tooltip>
            )}
            {!!topicsCount && (
              <Tooltip
                delay={1000}
                text={
                  <Plural
                    value={topicsCount}
                    one="# resource"
                    other="# resources"
                  />
                }
              >
                <Flex align="center">
                  <IconDoc size="sm" />
                  {topicsCount}
                </Flex>
              </Tooltip>
            )}
            {!!pathwaysCount && (
              <Tooltip
                delay={1000}
                text={
                  <Plural
                    value={pathwaysCount}
                    one="# Pathway"
                    other="# Pathways"
                  />
                }
              >
                <Flex align="center">
                  <IconMap />
                  {pathwaysCount}
                </Flex>
              </Tooltip>
            )}
            {!!campaignsCount && (
              <Tooltip
                delay={1000}
                text={
                  <Plural
                    value={campaignsCount}
                    one="# campaign"
                    other="# campaigns"
                  />
                }
              >
                <Flex align="center">
                  <IconEnergy />
                  {campaignsCount}
                </Flex>
              </Tooltip>
            )}
            {!!surveysCount && (
              <Tooltip
                delay={1000}
                text={
                  <Plural
                    value={surveysCount}
                    one="# survey"
                    other="# surveys"
                  />
                }
              >
                <Flex align="center">
                  <IconBubbles />
                  {surveysCount}
                </Flex>
              </Tooltip>
            )}
            {!!eventsCount && (
              <Tooltip
                delay={1000}
                text={
                  <Plural value={eventsCount} one="# Event" other="# Events" />
                }
              >
                <Flex align="center">
                  <IconCalendar />
                  {eventsCount}
                </Flex>
              </Tooltip>
            )}
          </div>
        </div>
      </Flex>
    </Card>
  )
}
